// @flow
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
// import '../../styles/css/astronaut.about-1.0.css'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import SupportListNew from '../partials/SupportListNew.jsx'
import BannerDemoNew from '../partials/BannerDemoNew.jsx'
import hero from '../../images/hero_img_about_us.png'
import imgChart from '../../images/img_about_us_01.png'
import manfredNigel from '../../images/manfred-nigel.png'
import teamMember1 from '../../images/team-member1.png'
import teamMember2 from '../../images/team-member2.png'
import teamMember3 from '../../images/team-member3.png'
import teamMember4 from '../../images/team-member4.png'
import teamMember5 from '../../images/team-member5.png'
import nigel from '../../images/Nigel.png'
import manfred from '../../images/Manfred.png'
import chandra from '../../images/Chandra.png'
import sheeren from '../../images/sheeren.png'
import galih from '../../images/Galih.png'
import devi from '../../images/Devi.png'
import vinsen from '../../images/vinsen.png'
import raya from '../../images/raya.png'
import nadya from '../../images/nadya.png'
import about1 from '../../images/about1.png'
import _axios from '../../dependencies/_axios'

import { UilAtom, UilProcessor } from '@iconscout/react-unicons'
import targetAlign from '../../images/target-align.svg'

import { connect } from 'react-redux'
import { translate } from '../../helpers/global'

type Props = {};

type State = {
	jobs: Array<Object>
};

class TeamPageNew extends React.Component<Props, State> {
  constructor() {
		super()

		this.state = {
			jobs: []
		}
	}

	componentDidMount() {

        _axios({
			url: `/astro-jobs`,
			timeout: 200000,
			method: 'get'
		})
		.then((response) => {
			this.setState({jobs: response.data})
		})
		.catch((error) => {
			console.error(error)
		})

		window.scrollTo(0, 0)
	}


  render() {
		const { jobs } = this.state
		const { globalGetLanguages, user } = this.props
		const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
		let cols = ''
		let videoNigel

		if (jobs.length) {
			if (jobs.length === 1) {
				cols = 'col-sm-12'
			} else if ( jobs.length === 2 ) {
				cols = 'col-sm-6'
			} else {
				cols = 'col-sm-4'
			}

			videoNigel =	jobs
				.map((item, index) => (
				<Fragment>
                    <source src={item.job_ads_video} type="video/mp4" />
                    Your browser does not support the video tag.
          		</Fragment>
				))
		}

    return (
		<div id="about">
	        <HeaderNewClear />
			{/* <section style={{paddingBottom: '180px'}}></section> */}
			<section className="pad-plus">
	          <div className="tit-about">
				<label>About ASTRNT</label>
				<h1>
					APAC’s Fastest-Growing Talent<br/>Technology Platform & Solutions Provider
				</h1>
	            <span>
				  Since 2016, ASTRNT has been transforming how employers and universities  in Asia-Pacific hire, assess, and select talent and customers. Together with our clients and partners, we make every process more cost effective, more inclusive, and much faster.
				</span>
	          </div>
	        </section>
			<div className="section-blue half-white relative text-center">
				<span className="white-curve-top-left"></span>
				<img className="hero-img" src={hero} alt="" />
				<span className="blue-curve-middle-right-flip"></span>
			</div>
			<div className="section-white relative">
				<section>
					<div className="card-about-container">
						<div className="card-item">
							<span><img src={targetAlign} /></span>
							<h3>Our Mission: Best Fit, Fast, Everywhere!</h3>
							<p>Whether you’re an employer, education provider, student or jobseeker, we make your life easier and bring you closer to success.</p>
							<p>We enable <strong>‘Best Fit, Fast, Everywhere’</strong> across the entire talent ecosystem, with our technology and solutions making hiring, matching and selection decisions much faster, more accurate and more cost effective.</p>
						</div>
						<div className="card-item">
							<span><UilAtom size="30" /></span>
							<h3>Improving Processes with Technology and Science</h3>
							<p>We are more than a technology provider. We are a company that deeply cares about process improvement and measurable results.</p>
							<p>Every capability we deliver is backed by <strong>science-based validation</strong>, designed to deliver real outcomes.<br/>We are excited about innovation, but we never lose sight of the impact on your business.</p>
						</div>
						<div className="card-item card-full-width">
							<h3><span className="proc"><UilProcessor size="30" /></span>Artificial Intelligence, Done Right with ‘ASTRNT Recommends’</h3>
							<div className="double-side">
								<div>
									<p>Artificial Intelligence is reshaping decision-making. At ASTRNT, we use it with purpose through our branded approach: <strong>ASTRNT Recommends</strong>.</p>
									<p><strong>ASTRNT Recommends</strong> provides AI-driven insights that highlight candidate potential, fit, and development needs. Every recommendation is built on validated science, tested rigorously with clients, and released only after meeting strict quality standards.</p>
								</div>
								<div>
									<p>For us, <strong>validation is non-negotiable</strong>. AI enhances decision-making, but science and human expertise remains at the core.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div className="section-blue relative">
				<section>
					<div className="about-chart">
						<div><img src={imgChart} /></div>
						<div>
							<h2>Built on Commitment and Growth Since 2016</h2>
							<p>ASTRNT has consistently grown year after year, trusted by enterprises, universities, and organisations across the region. We remain committed to delivering, supporting and evolving with our clients — proving that we are a partner for the long term.</p>
						</div>
					</div>
				</section>
			</div>
			<div className="section-red center triangle-right"
          style={{
			color: 'white',
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
			overflowWrap: "break-word",
			wordWrap: "break-word",
			overflow: "hidden",
          }}
        >
          <div style={{width: '730px', maxWidth: '90%', zIndex: 1, position: 'relative'}}>
            <h1 className='title-1'>
              Let’s Build the Future of Talent Together
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              We believe technology should make talent decisions faster, fairer and more effective. With every partnership, we move closer to a world where people are placed in roles where they thrive, and organisations achieve their goals with clarity.
            </p>
            <div>
              <a className='btn btn-primary-red' style={{ background: 'white',color: '#C04051'}} onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')}>
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
	        <FooterNew />
	      </div>
		)
  }
}

const mapStateToProps = (state) => {
    return{ 
      globalGetLanguages:state.globalGetLanguages,
	  user: state.user
    }
    
  }

export default connect(mapStateToProps, null )(TeamPageNew)
